import {Button, ButtonGroup} from 'platform/components';
import {Heading, VStack} from 'platform/foundation';

import {useDeleteServiceOrderIssueNoteBasketMutation} from '@dms/api/warehouse';
import i18n from '@dms/i18n';

interface EmptyServiceOrderIssueDialogProps {
  onDelete: VoidFunction;
  onDontDelete: VoidFunction;
}

export function EmptyServiceOrderIssueDialog(props: EmptyServiceOrderIssueDialogProps) {
  const [, {isLoading: isDiscardingBasket}] = useDeleteServiceOrderIssueNoteBasketMutation({
    fixedCacheKey: 'discard-soi-basket',
  });

  return (
    <VStack spacing={4}>
      <Heading size={4}>
        {i18n.t('entity.warehouse.labels.emptyServiceOrderIssueDeletePrompt')}
      </Heading>
      <ButtonGroup align="right">
        <Button
          isLoading={isDiscardingBasket}
          variant="secondary"
          title={i18n.t('entity.warehouse.actions.dontDelete')}
          onClick={props.onDontDelete}
        />
        <Button
          isLoading={isDiscardingBasket}
          variant="danger"
          title={i18n.t('entity.warehouse.actions.delete')}
          onClick={props.onDelete}
        />
      </ButtonGroup>
    </VStack>
  );
}
